/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export * from './skeleton.component';
export * from './skeleton.module';
export * from './skeleton.type';
export * from './skeleton-element.component';
